export var EOrderFromSystem;
(function (EOrderFromSystem) {
    EOrderFromSystem[EOrderFromSystem["\u5168\u90E8\u6765\u6E90"] = 0] = "\u5168\u90E8\u6765\u6E90";
    EOrderFromSystem[EOrderFromSystem["\u5BA2\u6237\u7CFB\u7EDF"] = 1] = "\u5BA2\u6237\u7CFB\u7EDF";
    EOrderFromSystem[EOrderFromSystem["\u5546\u57CE"] = 5] = "\u5546\u57CE";
    EOrderFromSystem[EOrderFromSystem["\u4EE3\u5BA2\u4E0B\u5355"] = 4] = "\u4EE3\u5BA2\u4E0B\u5355";
})(EOrderFromSystem || (EOrderFromSystem = {}));
export default EOrderFromSystem;
